import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=71656a9f&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"
import style0 from "./HowTo.vue?vue&type=style&index=0&id=71656a9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71656a9f",
  null
  
)

export default component.exports